import { api } from "../../lib/api";
import { useApi } from "../../lib/useApi";
import { Link } from "react-router-dom";
import { PageHeader, Spinner } from "../../components/ui";
import { money } from "../../lib/format";
import { PIPELINE_ORDER, PIPELINE_LABELS, PIPELINE_ACCENT, type PipelineStage } from "../../lib/pipeline";

interface PCase {
  id: string;
  publicRef: string;
  pipelineStage: PipelineStage;
  status: string;
  clientName: string | null;
  vehicleMake: string | null;
  vehicleModel: string | null;
  listedPriceMinor: number | null;
  listingCurrency: string | null;
  createdAt: number;
}

export function CrmPipeline() {
  const { data, loading, reload } = useApi<{ data: PCase[] }>("/api/crm/pipeline");
  async function move(id: string, stage: PipelineStage) {
    await api.patch(`/api/crm/cases/${id}/pipeline`, { stage });
    await reload();
  }

  const cases = data?.data ?? [];
  const byStage = new Map<PipelineStage, PCase[]>();
  for (const s of PIPELINE_ORDER) byStage.set(s, []);
  for (const c of cases) byStage.get(c.pipelineStage)?.push(c);

  return (
    <>
      <PageHeader title="Pipeline" subtitle="Estado de cada expediente: búsqueda → contacto → visita → inspección → compra → entrega" />
      {loading ? (
        <Spinner />
      ) : (
        <div className="flex gap-4 overflow-x-auto pb-4">
          {PIPELINE_ORDER.map((stage) => {
            const items = byStage.get(stage) ?? [];
            return (
              <div key={stage} className="w-64 shrink-0">
                <div className="mb-2 flex items-center justify-between rounded-lg border border-line bg-surface px-3 py-2">
                  <span className="flex items-center gap-2 text-sm font-semibold">
                    <span className="h-2.5 w-2.5 rounded-full" style={{ background: PIPELINE_ACCENT[stage] }} />
                    {PIPELINE_LABELS[stage]}
                  </span>
                  <span className="tnum text-xs text-muted">{items.length}</span>
                </div>
                <div className="flex flex-col gap-2">
                  {items.map((c) => (
                    <div key={c.id} className="card p-3">
                      <div className="flex items-center justify-between">
                        <Link to={`/cases/${c.id}`} className="font-mono text-sm font-medium text-accent-600 hover:underline">{c.publicRef}</Link>
                        <span className="tnum text-xs text-muted">{money(c.listedPriceMinor, c.listingCurrency ?? "EUR")}</span>
                      </div>
                      <div className="mt-1 text-sm">{c.vehicleMake} {c.vehicleModel}</div>
                      <div className="text-xs text-muted">{c.clientName ?? "—"}</div>
                      <select
                        value={c.pipelineStage}
                        onChange={(e) => void move(c.id, e.target.value as PipelineStage)}
                        className="mt-2 w-full rounded-lg border border-line bg-canvas px-2 py-1 text-xs text-muted focus:outline-none"
                      >
                        {PIPELINE_ORDER.map((s) => <option key={s} value={s}>{PIPELINE_LABELS[s]}</option>)}
                      </select>
                    </div>
                  ))}
                  {items.length === 0 && <div className="rounded-lg border border-dashed border-line px-3 py-6 text-center text-xs text-muted">—</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
